export default "__VITE_ASSET__gLb9WnS8__"